/*
  MedSuperfoods · convivencia del carrito de Dawn con Rebuy Smart Cart
  ---------------------------------------------------------------------------
  EL PROBLEMA. Con `cart_type: "notification"` el tema abría su propio panel en
  cada «Agregar al carrito», a la vez que Rebuy abría el suyo. Durante los ~360 ms
  que Rebuy tarda en entrar, el panel de Dawn quedaba solo en pantalla con sus
  botones PULSABLES, y «Pagar pedido» llevaba al pago saltándose el cross-sell.

  EL AJUSTE. `cart_type` pasa a `"page"`, así el tema no pinta `cart-notification`
  ni `cart-drawer` y no abre nada. Pero entonces Dawn, al no tener carrito que
  abrir, NAVEGA a `/cart` (product-form.js línea 70). Y como Rebuy tiene
  `disable_cart_page: true`, `/cart` reenvía a la home. El cliente saldría de la
  ficha.

  LO QUE HACE ESTE FICHERO. Decide en el último instante posible, ya con Rebuy
  cargado o no, en la fase de CAPTURA del `submit` — antes de que corra el
  manejador de Dawn, que va en fase de burbuja sobre el propio formulario.

    · Si Rebuy está disponible, le damos a Dawn un carrito de pega. Dawn añade el
      artículo, refresca el contador de la cabecera y se para ahí. Rebuy abre su
      cajón como hasta ahora.
    · Si Rebuy NO está, no tocamos nada. Dawn hace lo suyo de siempre y navega a
      `/cart`, que sin Rebuy delante sí pinta la página de carrito del tema.

  Y una red de seguridad para el caso peor — Rebuy presente pero que no llega a
  abrir. Sin ella el cliente pulsaría «Agregar al carrito» y no vería nada.
*/

(function () {
  'use strict';

  var ESPERA_MAXIMA = 4000; // ms que le damos a Rebuy para abrir antes de ir a /cart

  function rebuyDisponible() {
    return !!(window.Rebuy && window.Rebuy.SmartCart);
  }

  function rebuyAbierto() {
    return document.body.classList.contains('rebuy-cart-visible');
  }

  /* Mismo troceado que usa Dawn en cart-notification.js, para pintar la sección
     devuelta por /cart/add.js dentro del elemento que le corresponde. */
  function interiorDeLaSeccion(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var seccion = doc.querySelector('.shopify-section');
    return seccion ? seccion.innerHTML : null;
  }

  /* El carrito de pega. Cumple el contrato que product-form.js espera de un
     `cart-notification` sin abrir ninguna interfaz. Solo pide y repinta la
     burbuja del contador, que si no se quedaría atrasada. */
  var carritoSilencioso = {
    getSectionsToRender: function () {
      return [{ id: 'cart-icon-bubble' }];
    },
    setActiveElement: function () {},
    renderContents: function (respuesta) {
      var html = respuesta && respuesta.sections && respuesta.sections['cart-icon-bubble'];
      var destino = document.getElementById('cart-icon-bubble');
      if (!html || !destino) return;
      var interior = interiorDeLaSeccion(html);
      if (interior !== null) destino.innerHTML = interior;
    },
    classList: {
      contains: function () { return false; },
      remove: function () {}
    }
  };

  function vigilarQueRebuyAbra() {
    var limite = Date.now() + ESPERA_MAXIMA;
    (function mirar() {
      if (rebuyAbierto()) return;                       // abrió, no hacemos nada
      if (Date.now() < limite) return void setTimeout(mirar, 250);
      // Rebuy estaba pero no ha abierto. Llevamos al cliente al carrito, que es
      // lo que habría hecho Dawn por su cuenta.
      window.location = (window.routes && window.routes.cart_url) || '/cart';
    })();
  }

  document.addEventListener(
    'submit',
    function (evt) {
      var formulario = evt.target;
      if (!formulario || formulario.tagName !== 'FORM') return;
      if (!/\/cart\/add/.test(formulario.getAttribute('action') || '')) return;

      var elemento = formulario.closest('product-form');
      if (!elemento) return;

      // Sin Rebuy no tocamos nada: Dawn navega a /cart y esa es la ruta buena.
      if (!rebuyDisponible()) return;

      elemento.cart = carritoSilencioso;
      vigilarQueRebuyAbra();
    },
    true // CAPTURA · tiene que correr antes que el manejador de Dawn
  );
})();
